export default {
    computed: {
        canChangeAutoresponder () {
            return this.userCan("manage-mailboxes");
        }
    },
    methods: {
        checkAutoResponderStatus(mailbox) {
            let autoResponderStatus;

            if (_.isUndefined(mailbox.autoresponder) || mailbox.autoresponder === null) {
                autoResponderStatus = null;
            } else if (!_.isUndefined(mailbox.autoresponder.status)) {
                autoResponderStatus = mailbox.autoresponder.status;
            }

            return autoResponderStatus;
        },
        toggleAutoresponder(mailbox, data_update_type) {
            if(this.checkAutoResponderStatus(mailbox) === null) {
                return;
            }

            let autoResponderId = mailbox.autoresponder.id;
            let mailBoxId = mailbox.id;

            axios.post(`/settings/autoresponders/${autoResponderId}/mailbox/${mailBoxId}/toggle`)
                .then(response => {
                    toastr.success(response.data.message);

                    if(data_update_type === 'emit') {
                        this.$emit("auto-responder-updated", response.data.autoresponser, mailBoxId);
                    } else {
                        this.updateMailboxAutoResponder(response.data.autoresponser, mailBoxId);
                    }
                })
                .catch(error => {
                    toastr.error(error.response.data.message);
                });
        }
    }
}